import { queryOptions } from '@tanstack/react-query';

import type { useStripe } from '@/hooks/payments/useStripe';

import type { GetCashAppStatusResponse } from './types';

export const getCashAppStatusQuery = (
  stripe: ReturnType<typeof useStripe> | null,
  clientSecret?: string,
  enabled: boolean = true,
) => {
  return queryOptions({
    enabled: !!enabled && !!stripe && !!clientSecret,
    queryKey: ['cash-app-status', clientSecret],
    queryFn: async () => {
      const response = (await stripe?.retrieveSetupIntent(
        clientSecret ?? '',
      )) as { setupIntent: GetCashAppStatusResponse };

      if (!!response?.setupIntent.last_setup_error) {
        return Promise.reject(response.setupIntent.last_setup_error);
      }
      return response?.setupIntent;
    },
    refetchInterval: (query) => {
      const data = query.state.data;

      if (data?.last_setup_error) return false;
      if (data?.status === 'requires_action') {
        return 3000;
      }

      return 10000;
    },
  });
};
